import React from "react";
import "./SponsorInfo.css";

export const CurrentSponsors = () => {
  const sponsorData = [
    { name: "Fetch.ai", rank: "TERA" },
    { name: "Marshall Wace", rank: "GIGA" },
    { name: "Visa", rank: "GIGA" },
    { name: "Google", rank: "MEGA" },
    { name: "AWS", rank: "MEGA" },
    { name: "Hudson River Trading", rank: "MEGA" },
    { name: "D. E. Shaw Group", rank: "MEGA" },
    { name: "Sequoia Capital", rank: "MEGA" },
    { name: "Capital One", rank: "MEGA" },
    { name: "Brown University Office of the President", rank: "MEGA" },
    { name: "Gong", rank: "MEGA" },
    { name: "Bloomberg", rank: "KILO" },
    { name: "Old Mission Capital", rank: "KILO" },
  ];

  const partners = ["Voiceflow", "Jane Street", "MLH", "Warp, Redbull, Brown University Book Store, Insomnia Cookies, VIAM"];

  return (
    <div className="current-sponsors-board">
      <div className="sponsors-list">
        {sponsorData.map((sponsor, index) => (
          <div key={index} className="sponsor-entry">
            <div className={`sponsor-entry-name rank-${sponsor.rank.toLowerCase()}`}>{sponsor.name}</div>
            <div className={`sponsor-entry-rank rank-${sponsor.rank.toLowerCase()}`}>{sponsor.rank}</div>
          </div>
        ))}
      </div>

      <div className="partnership-section">
        <h3 className="partnership-title">IN PARTNERSHIP WITH</h3>
        <div className="partners-list">
          {partners.join(" • ")}
        </div>
      </div>
    </div>
  );
};  